export default "__VITE_ASSET__B8A_yb5h__"